// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
        p-slider{
            display:inline-block;
        }
        .ui-slider{
            background: #f5f5f5;
            height: 1px;
            border: solid 3px rgba(0, 0, 0, 0.1);
            border-radius: 3px;
            box-shadow:none;
        }
        .ui-slider .ui-slider-range{
            background: #0a6ed1 !important;
            height: 6px;
            position: relative;
            top: -2px;
            border-radius: 3px;
            left: -2px;
            box-shadow: none;
        }
        .ui-slider-horizontal .ui-slider-handle{
            top: -1.2rem !important;
        }
        .ui-slider .ui-slider-handle{
            width: 2.3rem !important;
            height: 2.3rem !important;
            cursor: default;
            outline: none;
            border-radius: 50%;
            border: none;
            background: #0a6ed1 !important;
            font-size: 1.2rem;
            text-align: center;
            color: rgb(255, 255, 255);
            font-family: 'Open Sans Condensed', sans-serif; 
            font-stretch: condensed;
        }
        .input-number–styledSpinners{
            width: 7rem;
            margin-right:1rem;
            height:2.6rem !important;
            margin-top:0.2rem;
        }
        .slider-label{
            font-family: 'Open Sans Condensed', sans-serif; 
            font-stretch: condensed;
            font-size: 1.2rem;
            color: rgba(0, 0, 0, 0.4)
        }
        .min-label{
            margin-right:2rem;
        }
        .max-label{
            margin-left:2rem;
        }
    `, "",{"version":3,"sources":["webpack://./src/app/components/administration/users/permissions-level-access-slider/permissions-level-access-slider.component.ts"],"names":[],"mappings":";QACQ;YACI,oBAAoB;QACxB;QACA;YACI,mBAAmB;YACnB,WAAW;YACX,oCAAoC;YACpC,kBAAkB;YAClB,eAAe;QACnB;QACA;YACI,8BAA8B;YAC9B,WAAW;YACX,kBAAkB;YAClB,SAAS;YACT,kBAAkB;YAClB,UAAU;YACV,gBAAgB;QACpB;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,wBAAwB;YACxB,yBAAyB;YACzB,eAAe;YACf,aAAa;YACb,kBAAkB;YAClB,YAAY;YACZ,8BAA8B;YAC9B,iBAAiB;YACjB,kBAAkB;YAClB,yBAAyB;YACzB,8CAA8C;YAC9C,uBAAuB;QAC3B;QACA;YACI,WAAW;YACX,iBAAiB;YACjB,wBAAwB;YACxB,iBAAiB;QACrB;QACA;YACI,8CAA8C;YAC9C,uBAAuB;YACvB,iBAAiB;YACjB;QACJ;QACA;YACI,iBAAiB;QACrB;QACA;YACI,gBAAgB;QACpB","sourcesContent":["\n        p-slider{\n            display:inline-block;\n        }\n        .ui-slider{\n            background: #f5f5f5;\n            height: 1px;\n            border: solid 3px rgba(0, 0, 0, 0.1);\n            border-radius: 3px;\n            box-shadow:none;\n        }\n        .ui-slider .ui-slider-range{\n            background: #0a6ed1 !important;\n            height: 6px;\n            position: relative;\n            top: -2px;\n            border-radius: 3px;\n            left: -2px;\n            box-shadow: none;\n        }\n        .ui-slider-horizontal .ui-slider-handle{\n            top: -1.2rem !important;\n        }\n        .ui-slider .ui-slider-handle{\n            width: 2.3rem !important;\n            height: 2.3rem !important;\n            cursor: default;\n            outline: none;\n            border-radius: 50%;\n            border: none;\n            background: #0a6ed1 !important;\n            font-size: 1.2rem;\n            text-align: center;\n            color: rgb(255, 255, 255);\n            font-family: 'Open Sans Condensed', sans-serif; \n            font-stretch: condensed;\n        }\n        .input-number–styledSpinners{\n            width: 7rem;\n            margin-right:1rem;\n            height:2.6rem !important;\n            margin-top:0.2rem;\n        }\n        .slider-label{\n            font-family: 'Open Sans Condensed', sans-serif; \n            font-stretch: condensed;\n            font-size: 1.2rem;\n            color: rgba(0, 0, 0, 0.4)\n        }\n        .min-label{\n            margin-right:2rem;\n        }\n        .max-label{\n            margin-left:2rem;\n        }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
